import {
  Container,
  Divider,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import HeaderBar from 'components/ui/HeaderBar';
import TabAnalyticsReport from '../components/TabAnalyticsReport';
import TabMembersReport from '../components/TabMembersReport';
import TabReportsReport from '../components/TabReportsReport';

export default function PageReports() {
  return (
    <Tabs defaultIndex={0} variant="line">
      <HeaderBar
        title="Relatórios"
        description="Gere relatórios de Envios, Membros e Reports"
      >
        <TabList>
          <Tab>Membros</Tab>
          <Tab>Reports enviados</Tab>
          <Tab>Analytics</Tab>
        </TabList>
      </HeaderBar>
      <Divider />

      <Container flexDirection="column">
        <TabPanels>
          <TabPanel>
            <TabMembersReport />
          </TabPanel>
          <TabPanel>
            <TabReportsReport />
          </TabPanel>
          <TabPanel>
            <TabAnalyticsReport />
          </TabPanel>
        </TabPanels>
      </Container>
    </Tabs>
  );
}
